
import React, { useEffect, useRef } from "react";

const Check = ({
  id,
  labeltext,
  type,
  indeterminate,
  hasError,
  isContentFound,
  ...inputProps

}) => {
  const selectorRef = useRef(null);

  useEffect(() => {
    selectorRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  const checkboxClassname = `
    m-checkbox
    ${type === "switch" && "m-checkbox--switch"}
    ${hasError && "m-checkbox--has-error"}
  `;

  const inputClassname = `
    m-checkbox__input
    ${type === "switch" && "m-checkbox--switch__input"}
    ${hasError && "m-checkbox--has-error__input"}
  `;

  const labelClassname = `
    m-checkbox__label
    ${type === "switch" && "m-checkbox--switch__label"}
  `;


  return (
    <div className={checkboxClassname}>
      <input
        type="checkbox"
        disabled={!isContentFound}
        className={inputClassname}
        ref={selectorRef}
        id={id}
        {...inputProps}
      />
      <label className={labelClassname} htmlFor={id}>
        {labeltext}
      </label>
    </div>
  );
};

Check.defaultProps = {
  type: "default",
  hasError: false,
  indeterminate: undefined
};

export default Check;


